/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { format } from "date-fns";
import { scheduleApi, type Schedule } from "../api/schedule";
import NavBar from "./NavBar";
import Hero from "./Hero";
import FeaturedShows from "./FeaturedShows";
import History from "./History";
import AdvertisementSection from "./AdvertisementSection";
import Footer from "./Footer";
import DailySchedule from "./schedule/DailySchedule";
import { useAuth } from "../contexts/AuthContext";
import ContactPage from "./ContactPage";

interface LandingPageData {
  scheduleItems: Schedule[];
  featuredShows: Array<{
    id: string;
    name: string;
    hostName: string;
    description?: string;
    thumbnail?: string;
    isActive: boolean;
    categories: Array<{
      id: string;
      name: string;
      isActive: boolean;
    }>;
    createdAt?: string; // Make these optional
    updatedAt?: string; // to match the Show type
  }>;
  historyItems: Schedule[];
}

export default function LandingPage() {
  const {setLandingPageData, setLandingDataLoading} = useAuth()
  const [data, setData] = useState<LandingPageData>({
    scheduleItems: [],
    featuredShows: [],
    historyItems: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [playing, setPlaying] = useState<"live_song" | "normal_song" | null>(null);

  const fetchData = async () => {
    try {
      setLandingDataLoading(true)
      setIsLoading(true);
      const today = format(new Date(), "yyyy-MM-dd");
      const response = await scheduleApi.getLandingPageData(today);
      // console.log("response", response.data)
      if (response.success) {
        const data = {
          scheduleItems: response.data.scheduleItems
            .filter((schedule) => {
              const scheduleDate = schedule.date.split("T")[0];
              return scheduleDate === today && schedule.isActive;
            })
            .map((schedule) => ({
              ...schedule,
              iconPath: "/path-to-icon",
              gradient: "from-[#174868] to-[#147b89]",
            })),
          featuredShows: response.data.featuredShows,
          historyItems: response.data.historyItems,
        }
        setData(data);
        setLandingPageData(data);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
      setLandingDataLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <main className="min-h-screen w-full relative text-white">
      <NavBar />
      <section id="home">
        <Hero
          currentPlaying={playing == "live_song"}
          setPlaying={setPlaying}
         />
      </section>
      <section id="schedule">
        <DailySchedule
          scheduleItems={data.scheduleItems}
          isLoading={isLoading}
        />
      </section>
      <AdvertisementSection />
      <section id="shows">
        <FeaturedShows
          featuredShows={data.featuredShows as any}
          isLoading={isLoading}
        />
      </section>
      <section id="history">
        <History 
          historyItems={data.historyItems} 
          isLoading={isLoading}
          currentPlaying={playing == "normal_song"}
          setPlaying={setPlaying}
        />
      </section>
      <section id="contact">
        <ContactPage />
      </section>
      <Footer />
    </main>
  );
}
